import { modifier } from 'ember-modifier';
import { computePosition, flip as flipfn, shift, offset as offsetfn } from '@floating-ui/dom';
import type { Placement } from '@floating-ui/dom';
import '@oddbird/popover-polyfill';

interface PositionerOptions {
  width?: number;
  placement?: Placement;
  padding?: number;
  offset?: number;
  flip?: boolean;
}
export interface AditoolsPositionerSignature {
  Element: HTMLElement;
  Args: {
    Positional: [];
    Named: PositionerOptions;
  };
}

const positioner = modifier<AditoolsPositionerSignature>(
  (element, _, { width, placement, padding, offset, flip }) => {
    const positionPopover = function (event: Event) {
      // The width calculation could be abstracted into a helper and passed to the modifier
      // This would allow for a more reuasable modifier
      const _placement: Placement = (placement as Placement | undefined) ?? 'bottom';
      const _padding = padding ?? 8;
      const _offset = offset ?? 0;
      const _flip = flip ?? true;
      const invoker = document.querySelector(`[popovertarget="${element.getAttribute('id')}"`) as HTMLElement;
      if (typeof width !== undefined) {
        element.style.width = `${width}px`;
      }
      if ((event as ToggleEvent).newState === 'open') {
        const middleware = [];
        if (_offset !== 0) {
          middleware.push(offsetfn(_offset));
        }
        if (_flip) {
          middleware.push(flipfn());
        }
        middleware.push(shift({ padding: _padding }));
        computePosition(invoker, element as HTMLElement, {
          placement: _placement,
          middleware: middleware,
        }).then(({ x, y }) => {
          Object.assign(element.style, {
            left: `${x}px`,
            top: `${y}px`,
          });
        });
      }
    };
    element.addEventListener('toggle', positionPopover);
    return () => {
      element.removeEventListener('toggle', positionPopover);
    };
  },
  { eager: false }
);
export default positioner;
